@if ((fullscreenTile$ | async) !== null) {
  <div #fullscreenRef class="fullscreen-tile cdk-overlay-dark-backdrop">
    <ndt-tile-wrapper
      [tileConfig]="fullscreenTile$ | async"
      [isEditing]="false"
      [isFullscreen]="true"
    ></ndt-tile-wrapper>
  </div>
}
<lcs-loading-overlay [show]="callState$ | async | lcsCallState : 'loading'">
  @if (selectedDashboard$ | async) {
    <ndt-dashboard-header-bar
      [class.hasScrolled]="hasScrolled"
      [dashboards]="dashboards$ | async"
      [selectedDashboard]="selectedDashboard$ | async"
      [isEditing]="isEditing"
      [addDashboardCancel]="addDashboardCancel"
      (addTile)="onAddTile()"
      (addDashboard)="onAddDashboard()"
      (deleteDashboard)="onDeleteDashboard()"
      (editToggle)="onEditToggle($event)"
      (renameDashboard)="onRenameDashboard($event)"
    ></ndt-dashboard-header-bar>
  }
  <div id="dashboard-scroll-container" (scroll)="onScroll($event)">
    <ndt-dashboard-view
      #dashboardView
      [adminToken]="adminToken"
      [selectedDashboard]="selectedDashboard$ | async"
      [isEditing]="isEditing"
      [dashboards]="dashboards$ | async"
      [callState]="callState$ | async"
      [preservedLayout]="preservedLayout$ | async"
      (addTile)="onAddTile()"
      (addDashboard)="onAddDashboard()"
      (layoutUpdated)="onLayoutUpdated($event)"
    ></ndt-dashboard-view>
  </div>
</lcs-loading-overlay>
